import { Controller } from "@hotwired/stimulus"

// Reports page tabs (Decision 3) — Reports / Summary Reports / Custom
// Export. Owner-only; the tab bar isn't rendered for other roles, so
// this controller simply no-ops when there are no tab targets.
export default class extends Controller {
  static targets = ["tab", "panel"]

  // Open the tab named in ?tab= on load (e.g. arriving from the
  // /customReports → Reports redirect with ?tab=custom).
  connect() {
    const tab = new URLSearchParams(window.location.search).get("tab")
    if (tab && this.tabTargets.some((t) => t.dataset.tab === tab)) {
      this.show(tab)
    }
  }

  switch(event) {
    const key = event.currentTarget.dataset.tab
    this.show(key, { updateUrl: true })
  }

  // Lets other elements (e.g. an owner chip in Tab 1) jump to a tab.
  showTab(event) {
    const key = event.currentTarget.dataset.targetTab
    if (key) this.show(key, { updateUrl: true })
  }

  show(key, { updateUrl = false } = {}) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === key
      // Segmented-control styling (matches Action Items / Company Settings).
      tab.classList.toggle("text-brand", active)
      tab.classList.toggle("font-bold", active)
      tab.classList.toggle("text-text-muted", !active)
      tab.classList.toggle("font-medium", !active)
      tab.classList.toggle("hover:text-gray-700", !active)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== key)
    })
    if (updateUrl) this._syncUrl(key)
  }

  // Reflect the active tab in the address bar so it's shareable and a
  // refresh stays put: Reports → /reports, Custom Exports → /reports?tab=custom.
  _syncUrl(key) {
    const url = new URL(window.location.href)
    if (key === "reports") {
      url.searchParams.delete("tab")
      url.searchParams.delete("folder_id") // folder filter is Custom-Exports-only
    } else {
      url.searchParams.set("tab", key)
    }
    window.history.replaceState({}, "", url)
  }
}
